<template>
  <section class="preview-container flex-r">
    <!-- header -->
    <x-header class="xheader">
      <div class="left flex-r">
        <el-button @click="back"
          ><span class="back flex-r tc"
            ><icon src="gsm-arrow-left-line"></icon
            ><span class="text">退出预览</span></span
          ></el-button
        >
      </div>

      <div class="right">
        <!-- <el-button>设置</el-button> -->
        <el-button class="btn save" type="primary" @click="handleSave">
          保存
          <!-- <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>临时保存</el-dropdown-item>
            <el-dropdown-item>分享</el-dropdown-item>
          </el-dropdown-menu> -->
        </el-button>
      </div>
    </x-header>

    <section class="main-container flex-r">
      <!-- 手机预览 -->
      <section class="phone-wrapper flex-r">
        <div class="inner-wrapper" id="phone">
          <!-- 组件布局 -->
          <iframe
            :src="url"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
      </section>
      <!-- 二维码预览 -->
      <section class="qrcode-wrapper flex-c">
        <div class="qrcode" @click="go">
          <qrcode-vue :value="url" :size="170" level="H" />
        </div>
        <p class="title">手机扫描二维码预览效果</p>
        <el-button style="width: 90%" plain @click.native="copyLink()"
          >复制链接</el-button
        >
      </section>
    </section>
  </section>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
import XHeader from '@/components/XHeader/Index.vue'
import api from '@/Api.js'
export default {
  /******************************************
   ** 预览
   * @description 预览
   * @author stone
   *****************************************/
  name: 'preview-container',
  components: {
    XHeader,
    QrcodeVue
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    url () {
      const id = this.$route.params.id
      return `${window.location.origin}/page/${id}`
    },
    modulesList () {
      return this.$store.state.page.moduleList
    },
    currentModuleIndex () {
      return this.$store.state.page.currentModuleIndex
    }
  },
  methods: {
    async handleSave () {
      const id = this.$route.params.id
      const res = await api.updatePageById(id, this.$store.state.page)
      if (res.updated > 0) {
        this.$message({
          message: '发布成功',
          type: 'success'
        })
      }
    },
    checkThis (index) {
      this.$store.state.page.currentModuleIndex = index
      console.log('当前编辑：', this.$store.state.page.currentModuleIndex)
    },
    go () {
      this.$router.push({
        name: 'Page',
        params: {
          id: this.$route.params.id
        }
      })
    },
    copyLink () {
      const input = document.createElement('input')
      input.value = this.url
      input.style.opacity = 0
      input.style.position = 'absolute'
      input.style.zIndex = '-1'
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      this.$message({
        message: '已复制链接',
        type: 'success'
      })
      document.body.removeChild(input)
    },
    back () {
      this.$router.replace({
        name: 'Edit',
        params: {
          id: this.$route.params.id
        }
      })
    },
    // 载入页面信息
    async loadPage () {
      const id = this.$route.params.id
      const res = await api.getPageById(id)
      this.$store.state.page = res.source
    }
  },
  mounted () {
    if (this.$store.state.page.moduleList.length === 0) {
      this.loadPage()
    }
  }
}
</script>
<style lang="scss" scoped>
.preview-container {
  width: 100%;
  height: 100%;
  background: #f6f7f9;

  ::v-deep .xheader {
    font-size: 14px;
    font-weight: 800;
    color: #3e455c;

    .left {
      align-items: center;

      .el-button {
        border: 0;
        padding: 10px 20px;
      }

      .back {
        align-items: center;
        justify-content: center;
        font-size: 25px;

        .text {
          font-size: 14px;
          margin-left: 10px;
          font-weight: bold;
        }
      }
    }

    .right {
      .save {
        width: 130px;
      }
      .el-dropdown {
        margin-left: 5px;
      }
      .btn {
        .el-button--primary:first-child {
          width: 120px;
        }
      }
    }
  }

  .main-container {
    width: 100%;
    justify-content: center;
    height: 100%;
    align-items: center;
    overflow: auto;
    padding-top: 5%;
    padding-bottom: 5%;
    box-sizing: border-box;

    .phone-wrapper {
      background: #fff;
      width: 350px;
      height: 100%;
      align-items: center;
      justify-content: center;
      border: 5px solid rgba(0, 0, 0, 0.05);
      border-radius: 40px;

      .inner-wrapper {
        width: 330px;
        height: 90%;
        background: #fff;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.05);
        overflow: auto;
      }
    }

    .qrcode-wrapper {
      background: #fff;
      width: 200px;
      height: 290px;
      border-radius: 10px;
      margin-left: 50px;
      align-self: flex-start;
      justify-content: flex-start;
      align-items: center;

      .qrcode {
        width: 170px;
        height: 170px;
        background: #efefef;
        margin: 20px auto 10px;
      }

      .title {
        font-size: 14px;
        margin: 10px 0;
      }

      .desc {
        font-size: 12px;
        color: #999;
      }
    }
  }
}
</style>
